import React, { useState, useEffect, useCallback, useRef } from "react";
import useStyles from "./style";
import {
  Button,
  Dialog, 
  DialogActions,
  DialogContent,
  DialogTitle,
  useMediaQuery,
  Grid,
  TextField,
  MenuItem
} from "@mui/material";
import { useTheme } from '@mui/material/styles';
import _ from "lodash";
import { useNavigate } from 'react-router-dom';
//Libs
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";

//Services
import DispatcherApi from "Services/Dispatcher";

const ServiceDelete = (props) => {
  const { openDialog, formvalues, handleClose , handledisagree , userType , subcmpnyName } = props;
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const classes = useStyles();
  const dispatch = useDispatch();
  const [activedrivers , setActivedrivers]= useState([]);
  const [selecteddriver , setSelecteddriver]= useState(null);
  const navigate = useNavigate();
  // Fetch Service Details

  const fetchnearbydrivers = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const data ={
      s_latitude:formvalues.s_latitude,
      s_longitude:formvalues.s_longitude,
      service_type:formvalues.service_type, 
    }
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.status === 200) {
      //  console.log("fetched nearby drivers--->",res.data);
        setActivedrivers(res.data?.data);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "No drivers available around",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("Get member / partner details Api", err);
    };
    DispatcherApi.fetchnearbydrivers(data).then(onSuccess, onFailure);
  }, [formvalues]);
 
  useEffect(() => {
    openDialog && fetchnearbydrivers(); //getDetails();
  }, [openDialog]);

  const filteredDrivers = activedrivers.filter(
    (driver) =>
      userType !== "SUB COMPANY" ||
      (userType === "SUB COMPANY" && subcmpnyName && driver?.sub_companyName === subcmpnyName)
  );

  const handleselectedservicedrivers = (event) => {
    //console.log('selected services --->',event.target.value);
    setSelecteddriver(event.target.value); // Update selected value
  };

  const Assignselecteddriver = () => {
    dispatch(showLoader("Loading please wait..."));
    let validatationPass = true;
    formvalues.provider_id=selecteddriver;
    //console.log('assignedformvalues--->',formvalues);
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.status === 200 || res?.status === 201) {
        dispatch(
          showSnackbar({
            message: "Trip Assigned Successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );

        //console.log("the response data ", res?.data);
        navigate('/triplist');
        handleClose();
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Error in assign driver",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("update service details api error", err);
    };

    if (validatationPass) {
      DispatcherApi.assignridebydispatcher(formvalues).then(onSuccess, onFailure);
    }
  };

  return (
    <>
     <React.Fragment>
      <Dialog
        fullScreen={fullScreen}
        open={openDialog}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Select the nearby drivers to assign trip"}
        </DialogTitle>
        <DialogContent>
         
<Grid container spacing={2} rowSpacing={3} columnSpacing={4} className={classes.dialogbox}>
<Grid item xs={12} >
<div>
<TextField
    name="activedrivers"
    id="activedrivers"
    select
    label="Available drivers"
    onChange={handleselectedservicedrivers}
    value={selecteddriver? selecteddriver:"" }
    fullWidth
    variant="outlined"
     size="small"
    >
      {filteredDrivers.map((drivers) => (
    <MenuItem key={drivers._id} value={drivers._id}>
    {drivers.userDetails?.firstName+" "+drivers.userDetails?.lastName}
    </MenuItem>
     ))}
    </TextField>
</div>
</Grid>
</Grid> 

        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handledisagree}>
            Disagree
          </Button>
          <Button onClick={Assignselecteddriver} autoFocus>
            Agree
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
    </>
  );
};

export default ServiceDelete;
